import request from '@/utils/request'

const prefix = '/django_rest/company/job-template'

export default {
  getJobTemplateList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getJobTemplateById (templateId) {
    return request.get(`${prefix}/${templateId}`)
  },
  createJobTemplate (data) {
    return request.post(`${prefix}/`, data)
  },
  updateJobTemplate (templateId, data) {
    return request.put(`${prefix}/${templateId}`, data)
  }
}
